import { render, staticRenderFns } from "./AnnouncementsDrawer.vue?vue&type=template&id=8fed6914"
import script from "./AnnouncementsDrawer.vue?vue&type=script&lang=js"
export * from "./AnnouncementsDrawer.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsDrawer.vue?vue&type=style&index=0&id=8fed6914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports